import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ExpenseDocDetailResponse, ExpenseDocument, ExpenseResponse } from 'src/app/models/expense.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExpenseService } from 'src/app/services/expense.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-applies-pp',
  templateUrl: './applies-pp.component.html',
  styleUrls: ['./applies-pp.component.scss']
})
export class AppliesPpComponent {
  @Output() close = new EventEmitter<boolean>();
  @Input() docId: number;
  @Input() expenseDoc: ExpenseResponse;
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  expenseDocument: ExpenseDocument = null;
  details: ExpenseDocDetailResponse[] = [];
  totalPurchase = 0;
  buttonApplie: ButtonLoading = new ButtonLoading('btn-success', false, 'Aplicar', 'fa-save');

  year: number;
  month: number;
  years: number[] = [];
  months = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' },
  ];

  inputs = {
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  products: ProductResponse[] = [];
  filterProducts: ProductResponse[] = [];
  timeout = null;

  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;
  availableMonths: { value: number; label: string }[] = [];

  constructor(
    private productService: ProductService,
    private expenseService: ExpenseService,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.getProducts("");
    this.getExpenseDoc();
    this.getDetails();
    this.generateYears();
    // if (this.expenseDoc && this.expenseDoc.appliedToPP) {
    //   this.month = this.expenseDoc.monthAppliedToPP;
    //   this.year = this.expenseDoc.yearAppliedToPP;
    //   this.inputs.product.data.id = this.expenseDoc.appliedToPPType;
    // }
  }

  getDetails() {
    if (!this.expenseDoc) {
      return;
    }

    this.expenseService.getDetailDocument(this.docId).subscribe({
      next: (response: ResponseObject) => {
        this.details = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle del gasto" + error.error.message);
      }
    });
  }

  getExpenseDoc() {
    if (!this.expenseDoc) {
      return;
    }
    this.expenseService.getExpenseDoc(this.expenseDoc.documentId).subscribe({
      next: (response: ResponseObject) => {
        this.expenseDocument = response.data;
        if (this.expenseDocument != null && this.expenseDocument.applyToPP != null) {
          this.year = this.expenseDocument.yearAppliedToPP;
          this.month = this.expenseDocument.monthAppliedToPP;
          this.getProduct(this.expenseDocument.appliedToPPType)
          this.computeAvailableMonths(false);
        } else {
          const currentYear = new Date().getFullYear();
          const currentMonth = new Date().getMonth();
          this.year = currentYear;
          this.month = currentMonth + 1;
          this.computeAvailableMonths(false);
          const isMonthValid = this.availableMonths.some(
            m => m.value === this.month
          );
          if (!isMonthValid) {
            this.month = null;
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el gasto" + error.error.message);
      }
    });
  }

  getProduct(productId) {
    this.productService.getProductById(productId).subscribe({
      next: (response: ResponseObject) => {
        if (response.data) {
          this.inputs.product.class = "fa-circle-check";
          this.inputs.product.verified = true;
          this.inputs.product.data = response.data;
          this.inputs.product.value = response.data.name;
          this.changeInput(this.inputs.product, response.data.name, true, null, 'fa-circle-check', response.data);
        }
      },
      error: (error: HttpErrorResponse) => { }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data

        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;
    // this.addProduct();
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(true);
  }

  closeModalEmit() {
    this.closed.emit(true);
  }

  get total() {
    return (this.expenseDoc.total).toFixed(2);
  }

  subtotal(quantity: number, price: number) {
    return (quantity * price).toFixed(2);
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 1; i--) {
      this.years.push(i);
    }
  }

  getDisabledSave() {
    if (!this.inputs.product.verified || this.year == null || this.month == null || this.year == 0 || this.month == 0) {
      return true;
    }
    return false;
  }
  saveApplies() {
    if (!this.docId) {
      return;
    }

    const data = {
      year: this.year,
      month: this.month,
      ppType: this.inputs.product.data.id
    }

    this.buttonApplie.loading = true;
    this.expenseService.saveApplyPP(data, this.docId).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Gasto aplicado a PP correctamente.", "Éxito");
        this.buttonApplie.loading = false;
        this.closeModalEmit();
      },
      error: (error: any) => {
        const msg =
          error?.error?.data?.description ||
          "Error no mapeado.";
        this.toastService.error(msg, "Error");
        this.buttonApplie.loading = false;
      }
    });
  }

  getMonthByValue(value: number): { value: number; label: string } | null {
    return this.months.find(m => m.value === value) || null;
  }

  computeAvailableMonths(validate: boolean): void {
    if (!validate) {
      this.availableMonths = [...this.months];
      return;
    }

    if (!this.year) {
      this.availableMonths = [];
      return;
    }

    // Año actual → solo meses cerrados
    if (this.year === this.currentYear) {
      this.availableMonths = this.months.filter(
        m => m.value < this.currentMonth
      );
      return;
    }

    // Año futuro → ninguno
    if (this.year > this.currentYear) {
      this.availableMonths = [];
      return;
    }

    // Año pasado → todos
    this.availableMonths = [...this.months];
  }




}
